var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block subscriptions"},[_c('subscriptions',{attrs:{"loading":_vm.store.isFetching.subscriptions,"subscribed":_vm.store.subscribed}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a64caa4","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/subscriptions/sidebar_subscriptions.vue
// module id = null
// module chunks = 